export default __webpack_public_path__ + "static/media/host1.65939afe.svg";